import {
  Button,
  Col,
  Descriptions,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { HeaderPrintForm } from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useAppSelector } from "redux/hooks";
import "./config";
import { columns } from "./config";
import moment from "moment";
import { formatDateToString, getAge } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import { DashboardFilled } from "@ant-design/icons";
import "./PresModal.scss";
import { InfoItem } from "components/common/PrintForm";
const PresModal = (props) => {
  const { closeModal, getDetailPrescription } = props;
  const printRef = useRef<any>();
  const detailRecord = useAppSelector(
    (state) => state.medicineStore.detailRecord
  );
  const detailPhieu = getDetailPrescription();

  const fields1 = [
    { label: "Họ và tên", value: detailPhieu?.prescriptionDto?.hoTen },
    {
      label: "Ngày sinh",
      value: formatDateToString(
        detailPhieu?.prescriptionDto?.ngaySinh,
        FORMAT_TIME.dayFull
      ),
    },
    { label: "Tuổi", value: getAge(detailPhieu?.prescriptionDto?.ngaySinh) },
    {
      label: "Giới tính",
      value: detailPhieu?.prescriptionDto?.gioiTinh == "NA" ? "Nam" : "Nữ",
    },
    { label: "Điện thoại", value: detailPhieu?.prescriptionDto?.dienThoai },
  ];
  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(
        detailPhieu?.prescriptionDto?.thoiGianKham,
        FORMAT_TIME.dateTime
      ),
    },
    { label: "Mã bệnh nhân", value: detailPhieu?.prescriptionDto?.maBenhNhan },
    { label: "Mã phiếu khám", value: detailPhieu?.prescriptionDto?.maKB },
  ];

  const fields3 = [
    { label: "Địa chỉ", value: detailPhieu?.prescriptionDto?.diaChiTongHop },
  ];

  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="print-form-don-thuoc">
      <div ref={printRef} className="print-don-thuoc">
        <HeaderPrintForm></HeaderPrintForm>
        <div>
          <InfoItem
            fields1={fields1}
            fields2={fields2}
            fields3={fields3}
            idBenhNhan={detailPhieu?.prescriptionDto?.maBenhNhan}
            title={"ĐƠN THUỐC"}
            isChiefComplant={false}
            qr={false}
            // spanLeft={10}
            // spanRight={14}
          />

          <div className="container2" style={{ marginBottom: 12 }}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,

                  marginBottom: 12,
                }}
              ></Typography.Text>
            </Row>
            <div className="table-print">
              <Table
                bordered
                columns={columns}
                dataSource={detailRecord?.listPrescriptionDetailDto}
                pagination={false}
              ></Table>
            </div>
          </div>
          <div className="container2" style={{ marginBottom: 12 }}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 14,

                  marginBottom: 8,
                }}
              >
                Lời dặn bác sĩ
              </Typography.Text>
            </Row>
            <div>
              {detailPhieu?.prescriptionDto?.loiDanBacSi ??
                "........................................................................................................................................................."}
            </div>
          </div>
          <div className="container2" style={{ marginBottom: 12 }}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 14,

                  marginBottom: 8,
                }}
              >
                Khám lại xin mang theo đơn này
              </Typography.Text>
            </Row>
            <div style={{ fontFamily: "'Times New Roman' , Times, serif" }}>
              Bố hoặc mẹ của trẻ hoặc người đưa trẻ đến khám chữa bệnh:
              .........................................................................................................................................................
            </div>
          </div>

          <Sign
            nguoiThucHien={detailPhieu?.prescriptionDto?.tenBacSy ?? ""}
            label="Bác sĩ kê đơn"
            time={detailPhieu?.prescriptionDto?.thoiGianKham}
          ></Sign>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-form-don-thuoc"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default PresModal;
